import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { SidebarCollapseContext } from './SidebarCollapseContext';
import SidebarFlyout from './SidebarFlyout';
import SidebarIcon from './SidebarIcon';

interface IProps {
  label: string;
  icon?: string;
  iconSrc?: string;
  to?: string;
  href?: string;
  end?: boolean;
}

export default function SidebarLink({ label, icon, iconSrc, to, href, end }: IProps) {
  const { collapsed } = useContext(SidebarCollapseContext);

  if (collapsed) {
    return (
      <SidebarFlyout
        flyoutKey={href ?? to ?? label}
        label={label}
        icon={icon}
        iconSrc={iconSrc}
        to={to}
        href={href}
        end={end}
        items={[{ to, href, label }]} />
    );
  }

  const className = 'nav-link rounded-2 mx-1 px-3';

  return (
    <li className="nav-item position-relative" style={{ marginBottom: '0.125rem' }}>
      {href
        ? <a className={className} href={href} target="_blank" rel="noopener noreferrer">
          <SidebarIcon icon={icon} iconSrc={iconSrc} />
          <span className="flex-grow-1">{label}</span>
          <i className="bi-box-arrow-up-right small text-muted ms-2"></i>
        </a>
        : <NavLink className={className} to={to ?? ''} end={end}>
          <SidebarIcon icon={icon} iconSrc={iconSrc} />
          {label}
        </NavLink>}
    </li>
  );
}
